import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { reorderArray } from "ionic-angular";
import { GenFormBuilder } from "../../providers/form";
import { Utilities } from "../../providers/utilities";

@Component({
  selector: "app-gallery-resource-form",
  templateUrl: "gallery-resource-form.html",
})
export class GalleryResourceFormComponent {

  @Input() public resources: any[] = [];
  @Output() public emitResources = new EventEmitter();
  @Output() public emitResource = new EventEmitter();

  public form: FormGroup;
  public isReorder = false;
  public isForm = false;
  public inputTypeChange = false;
  public currentResource = null;
  public submitAttempt = false;

  constructor(
    public utilities: Utilities,
    private formBuilder: FormBuilder,
    private formGenerate: GenFormBuilder,
  ) { }

  public reorderItems(indexes) {
    const load = this.utilities.setLoading();
    return Promise.resolve()
      .then(() => reorderArray(this.resources, indexes))
      .then((newResources) => newResources.map((item, key) => ({ ...item, order: key })))
      .then((newResources) => this.emitResources.emit(newResources))
      .then(() => load.dismiss());
  }

  public addOrUpdate(current = null) {
    const load = this.utilities.setLoading();

    this.buildForm(current);

    return Promise.resolve()
      .then(() => {
        if (current) {
          this.currentResource = current;
        } else {
          this.currentResource = null;
        }
        return true;
      })
      .then(() => this.isForm = true)
      .then(() => load.dismiss());
  }

  public updateInput() {
    this.inputTypeChange = true;
    setTimeout(() => this.inputTypeChange = false, 200);
  }

  public createOrUpdateResource({ value, valid }) {
    if (valid) {
      const load = this.utilities.setLoading();

      return Promise.resolve()
        .then(() => this.emitResource.emit(value))
        .then(() => this.isForm = false)
        .then(() => load.dismiss());
    } else {
      this.utilities.consoleError("Form", this.form);
      this.utilities.setToast("Form contain errors", 3000, "top");
    }
  }

  private buildForm(info = null) {
    this.submitAttempt = false;

    this.form = this.formBuilder.group({});
    this.formGenerate.genInputString("id", this.form);
    this.formGenerate.genInputNumber("order", this.form);
    this.formGenerate.genInputString("hashtag", this.form, true);
    this.formGenerate.genInputString("type", this.form, true, "image");
    this.formGenerate.genInputString("resourceUrl", this.form, true);
    this.formGenerate.genToggle("state", this.form, false, true);

    if (info) {
      this.form.patchValue(info);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/gallery-resource-form/gallery-resource-form.ts